'use client';

import { c as _c } from "react/compiler-runtime";
import { Children, cloneElement, createContext, isValidElement, useContext, type ReactNode } from 'react';
import { localizedHref, type Locale } from './config';
import { translate, type Catalog } from './catalog';
const LocaleContext = createContext<{
  locale: Locale;
  catalog: Catalog;
}>({
  locale: 'ko',
  catalog: {}
});
export const useLanguage = () => {
  return useContext(LocaleContext);
};
export function LanguageProvider(t0) {
  const $ = _c(6);
  const {
    locale,
    catalog,
    children
  } = t0;
  let t1;
  if ($[0] !== catalog || $[1] !== locale) {
    t1 = {
      locale,
      catalog
    };
    $[0] = catalog;
    $[1] = locale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== children || $[4] !== t1) {
    t2 = <LocaleContext.Provider value={t1}>{children}</LocaleContext.Provider>;
    $[3] = children;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}

/** Translate presentation leaves only: never IDs, filter values, events or data records.
 * Server-rendered slots and interactive components share this renderer, without DOM mutation.
 */
export function TranslatedContent(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  const {
    locale,
    catalog
  } = useLanguage();
  if (locale === "ko") {
    return children;
  }
  let t1;
  if ($[0] !== catalog || $[1] !== children || $[2] !== locale) {
    const walk = nodes => Children.map(nodes, node => {
      if (typeof node === "string") {
        return translate(node, catalog);
      }
      if (!isValidElement(node)) {
        return node;
      }
      const props = node.props;
      if (props["data-korean-only"]) {
        return null;
      }
      if (node.type === "script" && props.type === "application/ld+json") {
        return null;
      }
      if (props.translate === "no" || node.type === "script" || node.type === "style") {
        return node;
      }
      const next = {};
      if (props.children !== undefined) {
        const leaves = Children.toArray(props.children as ReactNode);
        const onlyText = leaves.every(_temp);
        const joined = onlyText ? leaves.join("") : "";
        const translated = translate(joined, catalog);
        next.children = onlyText && translated !== joined ? translated : walk(props.children as ReactNode);
      }
      for (const key of ["aria-label", "title", "placeholder", "alt"]) {
        const value = props[key];
        if (typeof value === "string") {
          next[key] = translate(value, catalog);
        }
      }
      if (typeof props.href === "string") {
        next.href = localizedHref(props.href, locale);
      }
      return cloneElement(node, next);
    });
    t1 = walk(children);
    $[0] = catalog;
    $[1] = children;
    $[2] = locale;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp(child) {
  return typeof child === "string" || typeof child === "number";
}